import PageBuilderPage from '@src/components/battle/demo/blocks/PageBuilderPage'
import BattleDemoSecNavBar from '@src/components/navigationBar/secondary/BattleDemoSecNavBar'
import { ROUTE } from '@src/constants/route'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import useFetchPageBuilderBeginnersGuideIndexJson from '@src/hooks/json/useFetchPageBuilderBeginnersGuideIndexJson'
import { useEffect } from 'react'

const BeginnersGuideIndexPage = () => {
  const { data } = useFetchPageBuilderBeginnersGuideIndexJson()

  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<BattleDemoSecNavBar route={ROUTE.BATTLE_DEMO_BEGINNERS_GUIDE} />)

    return () => setupBar(null)
  }, [setupBar])

  if (!data) {
    return null
  }

  return <PageBuilderPage data={data} />
}

export default BeginnersGuideIndexPage
